import { useSelector, useDispatch } from 'react-redux'
import {
  selectNotificationsList,
  selectIsNotificationsLoading,
} from '../../store/notifications/selectors'
import { UserNotification, markAsReviewed } from '../../store/notifications'

/**
 * Return type for useNotificationPage hook
 * Contains notifications array and loading state
 */
type UseNotificationsType = {
  /** Array of user notifications */
  notifications: UserNotification[]
  /** Loading state indicating if notifications are being fetched */
  loading: boolean
  markAsReviewedHandler: (id: number) => void
}

/**
 * Custom hook for notifications page
 * Provides notifications list and loading state from Redux store
 * @returns Object containing notifications array and loading boolean
 */
export const useNotificationPage = (): UseNotificationsType => {
  const dispatch = useDispatch()
  // Get notifications list from Redux store
  const notifications = useSelector(selectNotificationsList)
  // Get loading state from Redux store
  const loading = useSelector(selectIsNotificationsLoading)

  const markAsReviewedHandler = (id: number) => {
    dispatch(markAsReviewed(id))
  }

  return {
    notifications,
    loading,
    markAsReviewedHandler,
  }
}
